import React, { Component, PropTypes } from 'react';
import _, { over } from 'lodash';
import { observer, inject } from 'mobx-react';
import { action, observable } from 'mobx';
import moment from 'moment';
import Form, { FormBody, DateInput, SelectInput, FormActions } from '../../Form';
import * as api from '../../../actions/api';
import GraphView from '../../GraphView';
import Spinner from '../../Spinner';
import FormMultiSelectInput from "../../FormMultiSelectInput";

const partialRange = {
    // 5 stations  and 10 days per fetch
    stationIndex1: 0,
    stationIndex2: 5,
    daysDifference: undefined,
    nDays: 0,
    mDays: 10,
}

@inject('stationStore', 'dataSeriesStore', 'parameterStore')
@observer
class AnalysisMeteorologicalPrecipitation extends Component {
    static contextTypes = {
        notify: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
    };

    static propTypes = {
        params: PropTypes.object.isRequired,
        route: PropTypes.object.isRequired,
    };

    @observable filters = {
        // station_id: null,
        // series_id: null,
        // parameter_id: null,
        stations: null,
        parameters: null,
        date_from: moment().add(-7, 'days').format('YYYY-MM-DD'),
        date_to: moment().format('YYYY-MM-DD'),
        period: 'Point',
    };
    @observable partialFilters = {
        stations: this.filters.stations,
        parameters: this.filters.parameters,
        date_from: this.filters.date_from,
        date_to: this.filters.date_to,
        period: 'Point',
    }
    @observable multiStationOptions = [];
    @observable multiParameterOptions = [];
    @observable parameters = [];
    @observable station = {};
    @observable stations = [];
    @observable observations = [];
    @observable dataSeriesItems = [];
    @observable loadingFlag = false;
    @observable progress = null;
    @observable currentFetchedStations = '';

    //for partially fetch
    @observable stationIndex = {
        stationIndex1: partialRange.stationIndex1,
        stationIndex2: partialRange.stationIndex2,
    }
    @observable days = {
        daysDifference: partialRange.daysDifference,
        nDays: partialRange.nDays,
        mDays: partialRange.mDays,
    }

    constructor(props) {
        super(props);

        this.state = {
            height: window.innerHeight,
            // product: '',
            series: 1, // props.seriesList[0].id,   // TODO Check if list is empty
            from: moment().subtract(1, 'days').format('YYYY-MM-DD'),
            to: moment().format('YYYY-MM-DD'),
            data: [],
            titleText: '',
            options: null,

            station_ids: [],
            statesParameters: [],
            processing: false,
        };
    }

    componentWillMount() {
        // const { notify } = this.context;
        const { stationStore, parameterStore } = this.props;

        // stationStore.fetchItems()
        //     .then(action(stations => {
        //         this.stations = stations.sort((a, b) => (a.name > b.name) ? 1 : -1);
        //         console.log(this.stations)
        //     }))
        //     .catch(notify.error);

        // parameterStore.fetchItems()
        //     .then(action(parameters => {
        //         this.parameters = parameters.sort((a, b) => (a.name > b.name) ? 1 : -1);
        //     }))
        //     .catch(notify.error);

        if (!stationStore.isLoading && stationStore.items.length === 0) stationStore.fetchItems();
        if (!parameterStore.isLoading && parameterStore.items.length === 0) parameterStore.fetchItems();
        this.populateOptions();
    }

    populateOptions = () => {
        const { stationStore, parameterStore } = this.props;
        if (stationStore.items.length === 0) {
            setTimeout(() => {
                this.populateOptions();
            }, 300)
        } else {
            this.multiStationOptions = stationStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, value: false, tags: item.tags }));
            this.multiParameterOptions = parameterStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, code: item.code, value: false }));
        }
    };

    @action reset(item) {
        if (!item) { return; }
        this.observations = item;
        this.loadingFlag = false;
    }
    // @action onChangeStationFilter = (e) => {
    //     // const { notify } = this.context;
    //     // const { stationStore, dataSeriesStore } = this.props;
    //     // const stationId = e.target.value;
    //     this.filters.station_id = e.target.value;
    // }
    // @action onChangeSeries = (e) => { this.filters.series_id = e.target.value; }

    onStationOptionClicked = item => item.value = !item.value;
    @action onChangePeriodFilter = (e) => { this.filters.period = e.target.value; }
    @action onChangeParameter = (e) => { this.filters.parameters = e.target.value; }
    @action onChangeDateFrom = (e) => { this.filters.date_from = e.target.value; }
    @action onChangeDateTo = (e) => { this.filters.date_to = e.target.value; }

    @action showObservations = (e) => {
        this.setState({ options: null })
        this.loadingFlag = true;
        const { notify } = this.context;
        e.preventDefault();

        this.currentFetchedStations = '';
        this.progress = 0;
        let maxStations = partialRange.stationIndex2;
        let maxDay = partialRange.mDays;

        this.resetStationIndex();
        this.resetDays(undefined);
        this.filters.stations = this.optionsReducer(this.multiStationOptions).map(item => item).join(',')
        // this.filters.stations = this.state.station_ids.filter(i => i).map(item => item.id).join(',')
        // console.log('filters: ', this.filters)

        const er = message => notify.error({ message });
        // if (!this.filters.station_id) { return er('Station filter required'); }
        // if (!this.filters.series_id) { retur7n er('Data Series filter required'); }

        if (!this.filters.stations) { this.loadingFlag = false; return er('Station filter required'); }
        if (!this.filters.parameters) { this.loadingFlag = false; return er('parameter filter required'); }
        if (!this.filters.date_from) { this.loadingFlag = false; return er('Start date filter required'); }
        if (!this.filters.date_to) { this.loadingFlag = false; return er('End date filter required'); }

        let stationsArray = this.filters.stations.split(',');
        let daysDifference = moment.duration(moment(this.filters.date_to).diff(moment(this.filters.date_from))).asDays();
        this.days.daysDifference = daysDifference;

        let loopLengthStation = (stationsArray.length / maxStations) > parseInt((stationsArray.length / maxStations), 10) ? parseInt((stationsArray.length / maxStations), 10) + 1 : parseInt((stationsArray.length / maxStations), 10);
        let loopLengthDate = (daysDifference / maxDay) > parseInt((daysDifference / maxDay), 10) ? parseInt((daysDifference / maxDay), 10) + 1 : parseInt((daysDifference / maxDay), 10);
        let overallResponseData = [];
        let loopCount = 0;
        // console.log('no of station: ', stationsArray.length)
        // console.log('loop for stations, days & total_loop', loopLengthStation, loopLengthDate, loopLengthStation * loopLengthDate)

        if (stationsArray.length > maxStations && daysDifference > maxDay) {
            // console.log('both greater');
            Array(loopLengthStation).fill(0).map((e, i) => i + 1).forEach(async (a, index1) => {

                await Array(loopLengthDate).fill(0).map((e, i) => i + 1).forEach(async (b, index2) => {

                    await api.analysis.fetchMore(
                        this.getPartialfilter(stationsArray, daysDifference, maxStations, maxDay, index1, index2, 'both greater')
                    )
                        .then((response) => {
                            this.currentFetchedStations = response.map(i => '"' + i.name + '"').join(',');
                            this.progress = (++loopCount * 100) / (loopLengthStation * loopLengthDate);
                            overallResponseData.push(...response);
                            // if (loopLengthStation === index1 + 1 && loopLengthDate === index2 + 1) 
                            // if ((overallResponseData.length === stationsArray.length * loopLengthDate)) {}
                            this.checkIfFinshed('fetched', null, overallResponseData, loopCount, (loopLengthStation * loopLengthDate))
                        })
                        .catch(err => {
                            this.progress = (++loopCount * 100) / (loopLengthStation * loopLengthDate);
                            overallResponseData.push(...[]);
                            this.checkIfFinshed('error', err, overallResponseData, loopCount, (loopLengthStation * loopLengthDate))
                            notify.error;
                            er(err);
                        });
                })
                // this.resetDays(daysDifference);
            })
        }
        else if (stationsArray.length > maxStations) {
            // console.log('stations greater')

            Array(loopLengthStation).fill(0).map((e, i) => i + 1).forEach(async (a, index1) => {
                await api.analysis.fetchMore(
                    this.getPartialfilter(stationsArray, daysDifference, maxStations, maxDay, index1, null, 'stations greater only')
                )
                    .then((response) => {
                        overallResponseData.push(...response);
                        this.currentFetchedStations = response.map(i => '"' + i.name + '"').join(',');
                        this.progress = (++loopCount * 100) / (loopLengthStation * loopLengthDate);
                        // if (loopLengthStation === index1 + 1) 
                        // if (overallResponseData.length === stationsArray.length) {}
                        this.checkIfFinshed('fetched', null, overallResponseData, loopCount, (loopLengthStation * loopLengthDate))
                    })
                    .catch(err => {
                        this.progress = (++loopCount * 100) / (loopLengthStation * loopLengthDate);
                        overallResponseData.push(...[]);
                        this.checkIfFinshed('error', err, overallResponseData, loopCount, (loopLengthStation * loopLengthDate))
                        // notify.error
                        er(err);
                    });
            })
        }
        else if (daysDifference > maxDay) {
            // console.log('days greater')
            Array(loopLengthDate).fill(0).map((e, i) => i + 1).forEach(async (b, index2) => {
                await api.analysis
                    .fetchMore(
                        this.getPartialfilter(stationsArray, daysDifference, maxStations, maxDay, null, index2, 'days greater only')
                    )
                    .then((response) => {
                        overallResponseData.push(...response);
                        this.currentFetchedStations = response.map(i => '"' + i.name + '"').join(',');
                        this.progress = (++loopCount * 100) / (loopLengthStation * loopLengthDate);
                        // if (loopLengthDate === index2 + 1) 
                        // if (overallResponseData.length === stationsArray.length * loopLengthDate) {}
                        this.checkIfFinshed('fetched', null, overallResponseData, loopCount, (loopLengthStation * loopLengthDate))
                    })
                    .catch(err => {
                        this.progress = (++loopCount * 100) / (loopLengthStation * loopLengthDate);
                        overallResponseData.push(...[]);
                        this.checkIfFinshed('error', err, overallResponseData, loopCount, (loopLengthStation * loopLengthDate))
                        // notify.error
                        er(err);
                    });
            })
        }
        else {
            // console.log('else condition')
            this.currentFetchedStations = this.multiStationOptions.reduce((acc, item) => {
                if (item.value === true) acc.push(item.name);
                return acc;
            }, []).map(i => '"' + i + '"').join(',');
            this.progress = 50;
            api.analysis
                .fetchMore(this.filters)
                .then((response) => {
                    this.progress = (++loopCount * 100) / (loopLengthStation * loopLengthDate);
                    this.checkIfFinshed('fetched', null, response, loopCount, (loopLengthStation * loopLengthDate))
                })
                .catch(err => {
                    overallResponseData.push(...[]);
                    this.progress = (++loopCount * 100) / (loopLengthStation * loopLengthDate);
                    this.checkIfFinshed('error', err, overallResponseData, loopCount, (loopLengthStation * loopLengthDate));
                    // notify.error;
                    er(err)
                });
        }
    };

    checkIfFinshed(type, err, overallResponseData, loopCount, totalLoop) {
        if (type == 'error') {
            console.trace(err);
        }
        if (loopCount === totalLoop) {
            // console.log('finished: ', overallResponseData);
            this.setState({ processing: true })
            setTimeout(() => {
                this.setGraphOptions(overallResponseData);
            }, 1000);
        }
    }
    // getParameterOptions() {
    //     const { statesParameters, station_ids } = this.state;
    //     let parameters = [];
    //     station_ids.forEach((item, index) => {
    //         if (statesParameters.find(i => i.station_id === item.id)) {
    //             // let arrayParameters = statesParameters[index].parameters.sort((a, b) => (a.name > b.name) ? 1 : -1);
    //             let arrayParameters = statesParameters.find(i => i.station_id === item.id).parameters.sort((a, b) => (a.name > b.name) ? 1 : -1);
    //             parameters = parameters.concat(arrayParameters);
    //         }
    //     })
    //     // return parameters;
    //     return this.parameters;
    // }
    resetDays(daysDifference) {
        this.days.daysDifference = daysDifference;
        this.days.nDays = partialRange.nDays;
        this.days.mDays = partialRange.mDays;
    }
    resetStationIndex() {
        this.stationIndex.stationIndex1 = partialRange.stationIndex1;
        this.stationIndex.stationIndex2 = partialRange.stationIndex2;
    }
    getPartialfilter(stationsArray, daysDifference, maxStations, maxDay, index1, index2, type) {

        if (type === 'stations greater only') {
            maxStations = index1 === 0 ? 0 : maxStations;
            this.stationIndex.stationIndex1 += maxStations;
            this.stationIndex.stationIndex2 += maxStations;

            return {
                stations: stationsArray.slice(this.stationIndex.stationIndex1, this.stationIndex.stationIndex2).map(i => i).join(','),
                parameters: this.filters.parameters,
                date_from: this.filters.date_from,
                date_to: this.filters.date_to,
                period: 'Point',
            }
        }
        else if (type === 'days greater only') {
            // console.log('days greater & days diff: ', this.days.daysDifference);
            if (index2 > 0) {
                this.days.nDays += maxDay;
                this.days.mDays += maxDay < this.days.daysDifference ? maxDay : this.days.daysDifference;
            }
            this.days.daysDifference -= maxDay;
            // console.log('stations: ', stationsArray.map(i => i).join(','))
            // console.log('date from : ', moment(`${this.filters.date_from}`).add(this.days.nDays, 'days').format('YYYY-MM-DD'));
            // console.log('date to: ', moment(`${this.filters.date_from}`).add(this.days.mDays, 'days').format('YYYY-MM-DD'))
            return {
                stations: stationsArray.map(i => i).join(','),
                parameters: this.filters.parameters,
                date_from: moment(`${this.filters.date_from}`).add(this.days.nDays, 'days').format('YYYY-MM-DD'),
                date_to: moment(`${this.filters.date_from}`).add(this.days.mDays, 'days').format('YYYY-MM-DD'),
                period: 'Point',
            }
        }
        else if (type === 'both greater') {

            if (index1 !== 0 && index2 === 0) {  // add update index for slice only in loop of station  i.e (1,0) , (2,0) ... (n,0) . (0,0) will be default value; 
                this.resetDays(daysDifference);
                this.stationIndex.stationIndex1 += maxStations;
                this.stationIndex.stationIndex2 += maxStations;
            }

            if (index2 > 0) {
                this.days.nDays += maxDay;
                this.days.mDays += maxDay < this.days.daysDifference ? maxDay : this.days.daysDifference;
            }
            this.days.daysDifference -= maxDay;

            return {
                stations: stationsArray.slice(this.stationIndex.stationIndex1, this.stationIndex.stationIndex2).map(i => i).join(','),
                parameters: this.filters.parameters,
                date_from: moment(`${this.filters.date_from}`).add(this.days.nDays, 'days').format('YYYY-MM-DD'),
                date_to: moment(`${this.filters.date_from}`).add(this.days.mDays, 'days').format('YYYY-MM-DD'),
                period: 'Point',
            }
        }
    }

    setGraphOptions(res) {
        this.reset(res);
        // this.progress = null;
        // console.log('at setGraphoption>> overallresponse :', res)

        const arrayHashmap = res.filter(i => i.parameters).map(item => {
            return {
                id: item.id, name: item.name, data: item.parameters[0].data ? item.parameters[0].data : [],
                parameter_name: item.parameters[0].parameter_name, parameter_unit_symbol: item.parameters[0].parameter_unit_symbol,
                parameter_code: item.parameters[0].parameter_code
            }
        }).reduce((obj, item) => {
            obj[item.id] ? obj[item.id].data.push(...item.data) : (obj[item.id] = { ...item });
            return obj;
        }, {})
        const mergedSortedArray = Object.values(arrayHashmap).map(observations => {
            if (observations && observations.data) {
                let sortedData = observations.data.sort((a, b) => (new Date(a.time)) - (new Date(b.time)));
                return {
                    name: observations.name, data: sortedData, id: observations.id, parameter_unit_symbol: observations.parameter_unit_symbol,
                    parameter_code: observations.parameter_code, parameter_name: observations.parameter_name
                }
            }
        })
        // console.log(mergedSortedArray)

        const { date_from: dateFrom, date_to: dateTo } = this.filters;
        const titleText = mergedSortedArray && mergedSortedArray.length > 0 ? `${mergedSortedArray[0].parameter_name} from ${dateFrom} to ${dateTo}` :
            "Parameter doesn't match / Response data at Parameter(null) / no data";

        let seriesDataArray = [];

        mergedSortedArray.forEach(observations => {
            if (observations && observations.data) {
                let sum = 0;
                // let mergedSortedArray = observations.data.sort((a, b) => (new Date(a.time)) - (new Date(b.time)));
                let data = observations.data.map(({ time, value }) => {
                    sum += value;
                    return [(new Date(time)).valueOf(), sum]
                });
                seriesDataArray.push(data);
            }
        })

        let seriesOptions;
        seriesOptions = mergedSortedArray.map((observations, index) => {
            return {
                name: observations.name + '  ' + observations.parameter_code + '(' + observations.parameter_unit_symbol + ')',
                type: 'spline',
                data: seriesDataArray[index]
            }
        })
        const options = {
            chart: { type: 'spline', zoomType: 'x' },
            title: { text: titleText },
            xAxis: {
                type: 'datetime',
                dateTimeLabelFormats: {
                    millisecond: '%H:%M:%S.%L',
                    second: '%H:%M:%S',
                    minute: '%H:%M',
                    hour: '%H:%M',
                    day: '%e. %b',
                    week: '%e. %b',
                    month: '%b \'%y',
                    year: '%Y',
                },
            },
            yAxis: {
                title: { text: '' }
            },
            legend: { layout: 'vertical', align: 'right', verticalAlign: 'middle' },
            series: seriesOptions,
        };

        this.setState({
            // data: dataState,
            // seriesData,
            titleText, options, processing: false
        });

        setTimeout(() => {
            this.progress = null;
        }, 1000);
    }

    optionsReducer = options => options.reduce((acc, item) => {
        if (item.value === true) acc.push(item.id);
        return acc;
    }, []);

    render() {
        const { options } = this.state;
        const { stationStore, children, parameterStore } = this.props;
        // console.log('parameterstore:', this.props.parameterStore);
        // console.log('for parameter code: ', this.multiParameterOptions);
        // console.log('progress: ', Math.floor(this.progress));
        // if (children) return React.cloneElement(children, { stations: this.optionsReducer(this.multiStationOptions), ...this.date });

        return (
            <div>
                <Form>
                    <FormBody>
                        <FormMultiSelectInput
                            id='station-multi-select'
                            label='Stations'
                            options={this.multiStationOptions}
                            optionClicked={this.onStationOptionClicked}
                            isLoading={stationStore.isLoading}
                            filterOptions={stationStore.filterStations}
                        />
                        <SelectInput
                            multiple
                            label={'Parameter'}
                            value={this.filters.parameters}
                            fields={{ label: 'name', value: 'id' }}
                            options={this.multiParameterOptions}
                            onChange={this.onChangeParameter}
                            filterOptions={parameterStore.filterParameters}
                        />

                        <DateInput
                            label={'Date From'}
                            value={this.filters.date_from}
                            onChange={this.onChangeDateFrom}
                        />
                        <DateInput
                            label={'Date To'}
                            value={this.filters.date_to}
                            onChange={this.onChangeDateTo}
                        />

                    </FormBody>
                    <FormActions>
                        <button onClick={this.showObservations}>View</button>
                    </FormActions>
                </Form>

                <div>
                    {this.loadingFlag ?
                        <div>
                            <Spinner />
                            {this.progress !== null ?
                                <div>
                                    {this.state.processing ? <pre>Fetching Completed</pre> :
                                        <pre><b>Fetching data of stations: </b>{<div><br />{this.currentFetchedStations}</div>}</pre>
                                    }
                                    <div style={{ backgroundColor: 'lightgrey', borderRadius: '10px', height: '20px', position: 'relative' }}>
                                        <div style={{ width: `${this.progress}%`, backgroundColor: '#367fa9', textAlign: 'center', borderRadius: '10px', height: '20px' }} />
                                        <span style={{ color: 'white', position: 'absolute', left: '50%', top: 0 }}>{Math.floor(this.progress)}%</span>
                                    </div>
                                </div>
                                : null}
                        </div>
                        : options && <GraphView options={options} />}
                </div>

            </div >
        );
    }
}

export default AnalysisMeteorologicalPrecipitation;


// WEBPACK FOOTER //
// ./src/components/Analysis/Meteorological/Precipitation1.js